import React, { useEffect, useRef, useState } from "react";
import { Mic } from "lucide-react";
import { toast } from "sonner";

const SR = typeof window !== "undefined" ? (window.SpeechRecognition || window.webkitSpeechRecognition) : null;
export const dictationSupported = !!SR;

// Browser Web Speech dictation. Calls onAppend(chunk) with each finalised phrase.
export function DictateButton({ onAppend, disabled, testid, className = "" }) {
    const [listening, setListening] = useState(false);
    const recRef = useRef(null);
    useEffect(() => () => { try { recRef.current?.stop(); } catch (e) { /* noop */ } }, []);

    const toggle = () => {
        if (!SR) { toast.error("Voice dictation isn't supported in this browser — try Chrome or Edge."); return; }
        if (listening) { try { recRef.current?.stop(); } catch (e) { /* noop */ } return; }
        const rec = new SR();
        rec.lang = "en-GB";
        rec.interimResults = false;
        rec.continuous = true;
        rec.onresult = (e) => {
            let chunk = "";
            for (let i = e.resultIndex; i < e.results.length; i++) {
                if (e.results[i].isFinal) chunk += e.results[i][0].transcript;
            }
            chunk = chunk.trim();
            if (chunk) onAppend(chunk);
        };
        rec.onerror = (e) => { if (!["aborted", "no-speech"].includes(e.error)) toast.error(`Dictation error: ${e.error}`); setListening(false); };
        rec.onend = () => setListening(false);
        recRef.current = rec;
        try { rec.start(); setListening(true); toast.info("Listening… tap the mic again to stop"); }
        catch (e) { /* already started */ }
    };

    return (
        <button type="button" onClick={toggle} disabled={disabled} data-testid={testid}
            aria-label={listening ? "Stop dictation" : "Dictate"}
            title={SR ? (listening ? "Stop dictation" : "Dictate — speak your text") : "Voice dictation not supported in this browser (try Chrome or Edge)"}
            className={`shrink-0 inline-flex items-center justify-center rounded-sm p-1.5 transition-colors ${listening ? "bg-rose-600 text-white animate-pulse" : "text-muted-foreground hover:text-brand hover:bg-slate-100"} disabled:opacity-40 ${className}`}>
            <Mic className="w-4 h-4" />
        </button>
    );
}
